<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>期间设置</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      期间设置
    </h1>
    <div class="view-content">
      <el-tabs type="border-card" v-model="schemeType">
        <el-tab-pane label="日报" value="0" v-if="$store.state.funcModuleArray.includes(1901010201)">
          <el-form ref="form0" :model="form0" label-width="100px">
            <!--        <el-card class="box-card">-->
            <!--          <div class="card-content">-->
            <!--            <el-form-item label="方案类型" class="wipe-mb">-->
            <!--              <el-radio-group v-model="form.schemeType">-->
            <!--                <el-radio label="0">日报</el-radio>-->
            <!--                <el-radio label="1">周报</el-radio>-->
            <!--                <el-radio label="2">月报</el-radio>-->
            <!--              </el-radio-group>-->
            <!--            </el-form-item>-->
            <!--          </div>-->
            <!--        </el-card>-->

            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告开始日期">
                  <span>每日</span>
                  <el-input v-model="form0.startTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form0.startTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>

                <el-form-item label="报告截止日期" class="wipe-mb">
                  <span>次日</span>
                  <el-input v-model="form0.endTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form0.endTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每天</span>
                  <el-input v-model="form0.reportTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form0.reportTime.minute" class="time-input"></el-input>
                  <span>分</span>
                  <span class="space">生成</span>
                  <span>前</span>
                  <el-input v-model="form0.reportTime.day" class="time-input"></el-input>
                  <span>天的数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button type="primary" @click="onSubmit('form0')" :loading="isLoading">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="周报" value="1" v-if="$store.state.funcModuleArray.includes(1901010202)">
          <el-form ref="form1" :model="form1" label-width="100px">
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告开始日期">
                  <span>每周第</span>
                  <el-input v-model="form1.startTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form1.startTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form1.startTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>

                <el-form-item label="报告截止日期" class="wipe-mb">
                  <span>次周第</span>
                  <el-input v-model="form1.endTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form1.endTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form1.endTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每周</span>
                  <el-input v-model="form1.reportTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form1.reportTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form1.reportTime.minute" class="time-input"></el-input>
                  <span>分</span>
                  <span class="space">生成</span>
                  <span>前</span>
                  <el-input v-model="form1.reportTime.week" class="time-input"></el-input>
                  <span>周的数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button type="primary" @click="onSubmit('form1')" :loading="isLoading">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="月报" value="2" v-if="$store.state.funcModuleArray.includes(1901010203)">
          <el-form ref="form2" :model="form2" label-width="100px">

            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告开始日期">
                  <span>每月第</span>
                  <el-input v-model="form2.startTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form2.startTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form2.startTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>

                <el-form-item label="报告截止日期" class="wipe-mb">
                  <span>次月第</span>
                  <el-input v-model="form2.endTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form2.endTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form2.endTime.minute" class="time-input"></el-input>
                  <span>分</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每月</span>
                  <el-input v-model="form2.reportTime.day" class="time-input"></el-input>
                  <span>日</span>
                  <el-input v-model="form2.reportTime.hour" class="time-input"></el-input>
                  <span>时</span>
                  <el-input v-model="form2.reportTime.minute" class="time-input"></el-input>
                  <span>分</span>
                  <span class="space">生成</span>
                  <span>前</span>
                  <el-input v-model="form2.reportTime.month" class="time-input"></el-input>
                  <span>月的数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button type="primary" @click="onSubmit('form2')" :loading="isLoading">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>

<script>
  import {setPeriod, getPeriod} from '@/api/index';

  export default {
    name: "PeriodSet",
    data: () => ({
      isLoading: false,
      schemeType: '0',
      form0: {
        startTime: {
          hour: '',
          minute: ''
        },
        endTime: {
          hour: '',
          minute: ''
        },
        reportTime: {
          day: '',
          hour: '',
          minute: ''
        }
      },
      form1: {
        startTime: {
          day: '',
          hour: '',
          minute: ''
        },
        endTime: {
          day: '',
          hour: '',
          minute: ''
        },
        reportTime: {
          week: '',
          day: '',
          hour: '',
          minute: ''
        }
      },
      form2: {
        startTime: {
          day: '',
          hour: '',
          minute: ''
        },
        endTime: {
          day: '',
          hour: '',
          minute: ''
        },
        reportTime: {
          month: '',
          day: '',
          hour: '',
          minute: ''
        }
      }
    }),
    created() {
      getPeriod().then(res => {
        if (0 === res.status) {
          let data = res.data;
          for (let item of data) {
            let start_time = JSON.parse(item.start_time);
            let end_time = JSON.parse(item.end_time);
            let exec_time = JSON.parse(item.exec_time);
            switch (item.period_type) {
              case 0:
                this['form' + item.period_type] = {
                  startTime: {
                    hour: start_time.hour,
                    minute: start_time.min
                  },
                  endTime: {
                    hour: end_time.hour,
                    minute: end_time.min
                  },
                  reportTime: {
                    day: exec_time.day,
                    hour: exec_time.hour,
                    minute: exec_time.min
                  }
                };
                break;
              case 1:
                this['form' + item.period_type] = {
                  startTime: {
                    day: start_time.day,
                    hour: start_time.hour,
                    minute: start_time.min
                  },
                  endTime: {
                    day: end_time.day,
                    hour: end_time.hour,
                    minute: end_time.min
                  },
                  reportTime: {
                    week: exec_time.week,
                    day: exec_time.day,
                    hour: exec_time.hour,
                    minute: exec_time.min
                  }
                };
                break;
              case 2:
                this['form' + item.period_type] = {
                  startTime: {
                    day: start_time.day,
                    hour: start_time.hour,
                    minute: start_time.min
                  },
                  endTime: {
                    day: end_time.day,
                    hour: end_time.hour,
                    minute: end_time.min
                  },
                  reportTime: {
                    month: exec_time.month,
                    day: exec_time.day,
                    hour: exec_time.hour,
                    minute: exec_time.min
                  }
                };
                break;

            }

          }

        }
      })
    },
    methods: {
      onSubmit(formName) {
        const decideNumber = /^\d+$/;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let values = {...this[formName]};
            let startTime = values.startTime;
            let endTime = values.endTime;
            let reportTime = values.reportTime;

            let period_type = this.schemeType;
            for (let i in startTime) {
              switch (i) {
                case 'day':
                  let temp = parseInt(startTime[i]);
                  if (startTime[i] === '' || !decideNumber.test(startTime[i])) {
                    this.$message.error('请正确填写开始日期');
                    return;
                  }else{
                    if(period_type==='1'&&(temp > 7 || temp < 1)){
                      this.$message.error('请正确填写开始日期,【日】范围1～7');
                      return;
                    }else if(period_type==='2'&&(temp > 31 || temp < 1)){
                      this.$message.error('请正确填写开始日期,【日】范围1～31');
                      return;
                    }

                  }
                  break;
                case 'hour':
                  let temp2 = parseInt(startTime[i]);
                  if (temp2 > 23 || temp2 < 0 || startTime[i] === '' || !decideNumber.test(startTime[i])) {
                    this.$message.error('请正确填写开始日期,【时】范围0～23');
                    return;
                  }
                  break;
                case 'minute':
                  let temp3 = parseInt(startTime[i]);
                  if (temp3 > 59 || temp3 < 0 || startTime[i] === '' || !decideNumber.test(startTime[i])) {
                    this.$message.error('请正确填写开始日期,【分】范围0～59');
                    return;
                  }
                  break;
              }

            }
            for (let i in endTime) {
              switch (i) {
                case 'day':
                  let temp = parseInt(endTime[i]);
                  if (endTime[i] === '' || !decideNumber.test(endTime[i])) {
                    this.$message.error('请正确填写开始日期');
                    return;
                  }else{
                    if(period_type==='1'&&(temp > 7 || temp < 1)){
                      this.$message.error('请正确填写开始日期,【日】范围1～7');
                      return;
                    }else if(period_type==='2'&&(temp > 31 || temp < 1)){
                      this.$message.error('请正确填写开始日期,【日】范围1～31');
                      return;
                    }

                  }
                  break;
                case 'hour':
                  let temp2 = parseInt(endTime[i]);
                  if (temp2 > 23 || temp2 < 0 || endTime[i] === '' || !decideNumber.test(endTime[i])) {
                    this.$message.error('请正确填写截止日期,【时】范围0～23');
                    return;
                  }
                  break;
                case 'minute':
                  let temp3 = parseInt(endTime[i]);
                  if (temp3 > 59 || temp3 < 0 || endTime[i] === '' || !decideNumber.test(endTime[i])) {
                    this.$message.error('请正确填写截止日期,【分】范围0～59');
                    return;
                  }
                  break;
              }
            }
            for (let i in reportTime) {
              switch (i) {
                case 'day':
                  let temp = parseInt(reportTime[i]);
                  if (reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                    this.$message.error('请正确填写报告生成日期');
                    return;
                  } else {
                    // 周报
                    if (period_type === '1' && (temp > 7 || temp < 1)) {
                      this.$message.error('请正确填写报告生成日期,【日】范围1～7');
                      return;
                    } else if (period_type === '2' && (temp > 31 || temp < 1)) {
                      this.$message.error('请正确填写报告生成日期,【日】范围1～31');
                      return;
                    } else if (period_type === '0' && temp > 999) {
                      this.$message.error('请正确填写报告生成日期,【日】范围0～999');
                      return;
                    }
                  }
                  break;
                case 'hour':
                  let temp2 = parseInt(reportTime[i]);
                  if (temp2 > 23 || temp2 < 0 || reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                    this.$message.error('请正确填写报告生成日期,【时】范围0～23');
                    return;
                  }
                  break;
                case 'minute':
                  let temp3 = parseInt(reportTime[i]);
                  if (temp3 > 59 || temp3 < 0 || reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                    this.$message.error('请正确填写报告生成日期,【分】范围0～59');
                    return;
                  }
                  break;
                case 'month':
                  let temp4 = parseInt(reportTime[i]);
                  if (reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                    this.$message.error('请正确填写报告生成日期');
                    return;
                  } else if (period_type === '2' && (temp4 > 999)) {
                    this.$message.error('请正确填写报告生成日期,【月】范围0～999');
                    return;
                  }
                  break;
                case 'week':
                  let temp5 = parseInt(reportTime[i]);
                  if (reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                    this.$message.error('请正确填写报告生成日期');
                    return;
                  } else if (period_type === '1' && (temp5 > 999)) {
                    this.$message.error('请正确填写报告生成日期,【周】范围0～999');
                    return;
                  }
                  break;
              }
            }

            let startTimeM = startTime.day * 24 * 60 + startTime.hour * 60 + startTime.minute;
            let endTimeM = endTime.day * 24 * 60 + endTime.hour * 60 + endTime.minute;
            if (period_type === '0') {
              startTimeM = startTime.hour * 60 + startTime.minute;
              endTimeM = endTime.hour * 60 + endTime.minute;
            }
            // if (startTimeM >= endTimeM) {
            //   this.$message.error('开始日期要小于截止日期');
            //   return;
            // }
            this.isLoading = true;

            let start_time = {
              hour: startTime.hour,
              min: startTime.minute
            };

            let end_time = {
              hour: endTime.hour,
              min: endTime.minute
            };

            let exec_time = {
              day: reportTime.day,
              hour: reportTime.hour,
              min: reportTime.minute
            };

            if (period_type !== '0') {
              start_time.day = startTime.day;
              end_time.day = endTime.day;
              if (period_type === '1') {
                exec_time.week = reportTime.week;
              } else if (period_type === '2') {
                exec_time.month = reportTime.month;
              }
            }
            start_time = JSON.stringify(start_time);
            end_time = JSON.stringify(end_time);
            exec_time = JSON.stringify(exec_time);
            setPeriod({start_time, end_time, exec_time, period_type}).then(res => {
              this.isLoading = false;
              if (0 === res.status) {
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        });

      },
    }
  }
</script>

<style scoped lang="scss">
  .box-card {
    margin-bottom: 20px;
  }

  .time-input {
    width: 50px;
    margin: 0 10px;
  }
  .space{
    padding: 0 10px;
  }

</style>